<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="公司名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=100
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="phone"
                    label="电话"
                    prop="phone"
                    :help="formErr.phone"
                    :validateStatus='!formErr.phone||formErr.phone==""?"":"error"'
            >
                <a-input
                        :maxLength=20
                        v-model="form.phone"
                        @change="(e) => { formErr.phone=''}"
                        @blur="(e) => {  form.phone = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="qq"
                    label="QQ"
                    prop="qq"
                    :help="formErr.qq"
                    :validateStatus='!formErr.qq||formErr.qq==""?"":"error"'
            >
                <a-input
                        :maxLength=20
                        v-model="form.qq"
                        @change="(e) => { formErr.qq=''}"
                        @blur="(e) => {  form.qq = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="wechat"
                    label="微信"
                    prop="wechat"
                    :help="formErr.wechat"
                    :validateStatus='!formErr.wechat||formErr.wechat==""?"":"error"'
            >
                <a-input
                        :maxLength=40
                        v-model="form.wechat"
                        @change="(e) => { formErr.wechat=''}"
                        @blur="(e) => {  form.wechat = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="addr"
                    label="地址"
                    prop="addr"
                    :help="formErr.addr"
                    :validateStatus='!formErr.addr||formErr.addr==""?"":"error"'
            >
                <a-textarea :maxLength=200 :rows="4" v-model="form.addr"
                            @change="(e) => { formErr.addr='' }"
                            @blur="(e) => {  form.addr = e.target.value.trim() }"/>

            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }" >
                确定
            </a-button>
            <a-button  @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "officeForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig,
                form: {
                    addr:"",
                    qq:"",
                    wechat:"",
                    phone:"",
                    name:""
                },
                formErr: {
                    addr:"",
                    qq:"",
                    wechat:"",
                    phone:"",
                    name:""
                },
                rules: {
                    name: [ {required: true, message: "请输入公司名称", trigger: "blur"},,{ whitespace: true, message: "请输入公司名称" },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  }, ],
                    qq: [{required: true, message: "请输入qq", trigger: "blur"}, {  whitespace: true, message: "请输入qq" },{pattern:/^\d{1,}$/,message: "只能填写数字"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.qq)}  , trigger: "blur"  },],
                    wechat: [{required: true, message: "请输入微信", trigger: "blur"}, {  whitespace: true, message: "请输入微信" }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.wechat)}  , trigger: "blur"  },],
                    phone: [{required: true, message: "请输入电话", trigger: "blur"}, {  whitespace: true, message: "请输入电话" },{pattern:/^[-0-9]+$/,message: "请填写正确电话"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.phone)}  , trigger: "blur"  },],
                    addr: [{required: true, message: "请输入地址", trigger: "blur"}, {  whitespace: true, message: "请输入地址" },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.addr)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.branchOffice.EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={ addr:"", qq:"", phone:"", name:"",wechat:"" }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.branchOffice.SUBMIT_ADD : url = API.branchOffice.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
